import { isNilOrEmpty } from '@rentguru/commons-utils';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { isNil } from 'lodash';
import { useCallback } from 'react';

import { fetchPendingInvitations } from 'src/auth/client';

export const pendingInvitationsQueryKey = ['pending-invitations'] as const;

export const usePendingInvitations = () => {
  const queryClient = useQueryClient();

  const { data: emails } = useQuery({
    queryKey: pendingInvitationsQueryKey,
    queryFn: fetchPendingInvitations,
    staleTime: 30_000,
  });

  const isEmailInvited = useCallback(
    (email?: string | null): boolean => {
      if (isNilOrEmpty(email) || isNil(emails)) {
        return false;
      }
      return emails.has(email.toLowerCase());
    },
    [emails]
  );

  const refresh = useCallback(
    () => queryClient.invalidateQueries({ queryKey: pendingInvitationsQueryKey }),
    [queryClient]
  );

  return { isEmailInvited, refresh };
};
